<div class="space-y-6">
  <div class="mb-6">
    <img src="/images/color-logo.svg" alt="Selecthor Logo" class="h-12" />
  </div>
  <div>
    <app-subsection-title key="provider.tender.mailPreview.title" />

    @if (mailText) {
      <div class="card p-4 bg-third-level">
        <div [innerHTML]="mailText"></div>
      </div>
    } @else {
      <div class="card p-4 bg-third-level">
        <p class="text-sm">
          {{ 'provider.tender.mailPreview.noContent' | transloco }}
        </p>
      </div>
    }
  </div>

  <div class="flex justify-end mt-6">
    <p-button
      label="{{ 'common.next' | transloco }}"
      (onClick)="goToNextTab()"
      data-testid="tender-mail-preview-next-button"
    >
    </p-button>
  </div>
</div>
